/*
 Ez valszeg használ6ó lesz
 https://www.npmjs.com/package/moddle-xml

 Séma validátor
 npm i libxml-xsd --save
 https://www.npmjs.com/package/libxml-xsd

 Xml összerakó js data-ból
 https://www.npmjs.com/package/xmlbuilder2
 */

/*
 Using:

 const invoiceData = {};
 const xmlDataObject = HelperNavExportXml.convertInvoiceDataToXmlDataObject(invoiceData);
 const xsdData = HelperNavExportXml.getXsdData();
 const validationErrors=HelperNavExportXml.validateXml(xmlDataObject, xsdData)

 */
import Helper from '@/helper/Helper';
import xsdNavExport from '@/helper/xsdNavExport';

// import invoiceDataXsd from '@/data/OSA_Schemas_v2/invoiceData.xsd';
// const invoiceDataXsd = fs.readFileSync(__dirname+'/invoiceData.xsd');

const moment = require('moment');
// const xsd = require('libxml-xsd');
const {create} = require('xmlbuilder2');
// const xmllint = require('./xmllint.js')
// import xmllint from '@/helper/xmllint';
// import xmllint from 'xmllint';

// const xmllint = require('xmllint')

// const {
//     validateXML,
//     validateXMLWithDTD,
//     validateXMLWithXSD
// } = require("validate-with-xmllint");

// const moment = require("moment");


// const {ipcRenderer} = require('electron');
// const machineId = require('node-machine-id').machineId;
// const machineIdSync = require('node-machine-id').machineIdSync;

const HelperNavExportXml = {

    /**
     * Removes XML-invalid characters from a string.
     * @param {string} string - a string potentially containing XML-invalid characters, such as non-UTF8 characters, STX, EOX and so on.
     * @param {boolean} removeDiscouragedChars - a string potentially containing XML-invalid characters, such as non-UTF8 characters, STX, EOX and so on.
     * @return : a sanitized string without all the XML-invalid characters.
     */
    removeXMLInvalidChars(string, removeDiscouragedChars = true){
        // remove everything forbidden by XML 1.0 specifications, plus the unicode replacement character U+FFFD
        var regex = /((?:[\0-\x08\x0B\f\x0E-\x1F\uFFFD\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))/g;
        string = string.replace(regex, "");

        if (removeDiscouragedChars) {
            // remove everything not suggested by XML 1.0 specifications
            regex = new RegExp(
                "([\\x7F-\\x84]|[\\x86-\\x9F]|[\\uFDD0-\\uFDEF]|(?:\\uD83F[\\uDFFE\\uDFFF])|(?:\\uD87F[\\uDF" +
                "FE\\uDFFF])|(?:\\uD8BF[\\uDFFE\\uDFFF])|(?:\\uD8FF[\\uDFFE\\uDFFF])|(?:\\uD93F[\\uDFFE\\uD" +
                "FFF])|(?:\\uD97F[\\uDFFE\\uDFFF])|(?:\\uD9BF[\\uDFFE\\uDFFF])|(?:\\uD9FF[\\uDFFE\\uDFFF])" +
                "|(?:\\uDA3F[\\uDFFE\\uDFFF])|(?:\\uDA7F[\\uDFFE\\uDFFF])|(?:\\uDABF[\\uDFFE\\uDFFF])|(?:\\" +
                "uDAFF[\\uDFFE\\uDFFF])|(?:\\uDB3F[\\uDFFE\\uDFFF])|(?:\\uDB7F[\\uDFFE\\uDFFF])|(?:\\uDBBF" +
                "[\\uDFFE\\uDFFF])|(?:\\uDBFF[\\uDFFE\\uDFFF])(?:[\\0-\\t\\x0B\\f\\x0E-\\u2027\\u202A-\\uD7FF\\" +
                "uE000-\\uFFFF]|[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]|[\\uD800-\\uDBFF](?![\\uDC00-\\uDFFF])|" +
                "(?:[^\\uD800-\\uDBFF]|^)[\\uDC00-\\uDFFF]))", "g");
            string = string.replace(regex, "");
        }
        return string;
    },

    getFieldNamesfromValidationError(errors, isPreCheck = false){
        let ret = [];

        console.log("BRÉKPOINT");
        // Array.prototype.forEach.call(errors, function (element) {
        for (let i in errors) {
            if (!errors.hasOwnProperty(i)) {
                continue;
            }
            const element = errors[i];

            console.log(element);
            const message = element.message;

            const arr1 = message.split('}');
            console.log(arr1);

            const arr2 = arr1[1].split("'");
            console.log(arr2);
            const field = arr2[0];

            if (!isPreCheck || (isPreCheck
                    && field !== "invoiceNumber"
                )) {

                if (ret.indexOf(field) === -1) {
                    ret.push(field);
                }

            }

        }
        return ret;
    },

    getFieldNamesfromXmlValidateErrors(errors, isPreCheck = false){
        let ret = [];

        Array.prototype.forEach.call(errors, function (element) {
            console.log(element);

            const arr1 = element.split('}');
            console.log(arr1);

            const arr2 = arr1[1].split("'");
            console.log(arr2);
            const field = arr2[0];

            if (!isPreCheck || (isPreCheck
                    && field !== "invoiceNumber"
                )) {
                // if (field !== "customerBankAccountNumber" && field !== "customerTaxNumber") {
                if (ret.indexOf(field) === -1) {
                    ret.push(field);
                }
                // }
            }
            // else {
            //     if (ret.indexOf(field) === -1) {
            //         ret.push(field);
            //     }
            // }
        })

        return ret;
    },
    getPack(packKey, packs){
        let ret = "";
        Array.prototype.forEach.call(packs, function (e, i) {
            if (Number(e.key) === Number(packKey)) {
                ret = e.value;
            }
        });
        return ret;
    },
    /**
     * packs: [
     {key: '1', value: modul.$t('global.money')},
     {key: '2', value: modul.$t('global.pc')},
     {key: '3', value: modul.$t('global.kg')},
     {key: '4', value: modul.$t('global.l')},
     {key: '5', value: modul.$t('global.m')},
     {key: '6', value: modul.$t('global.pack')},
     {key: '7', value: modul.$t('global.occasion')},
     ],
     * @param packKey
     * @param packs
     * @returns {string}
     */
    navGetPack(packKey, packs){
        let ret = "";
        Array.prototype.forEach.call(packs, function (e, i) {
            if (Number(e.key) === Number(packKey)) {
                ret = e.value;
            }
        });
        if (ret === "db") {
            ret = 'PIECE';
        }
        if (Number(packKey) === Number("1")) {
            ret = 'OWN';
        }
        if (Number(packKey) === Number("2")) {
            ret = 'PIECE';
        }
        if (Number(packKey) === Number("3")) {
            ret = 'KILOGRAM';
        }
        if (Number(packKey) === Number("4")) {
            ret = 'LITER';
        }
        if (Number(packKey) === Number("5")) {
            ret = 'METER';
        }
        if (Number(packKey) === Number("6")) {
            ret = 'PACK';
        }
        if (Number(packKey) === Number("7")) {
            ret = 'PIECE';
        }
        // NAV available:
        // {'PIECE', 'KILOGRAM', 'TON', 'KWH', 'DAY', 'HOUR', 'MINUTE', 'MONTH', 'LITER', 'KILOMETER', 'CUBIC_METER', 'METER', 'LINEAR_METER', 'CARTON', 'PACK', 'OWN'}

        return ret;
    },
    /**
     *
     * @param modul
     * @param invoice_elements
     * @returns {Array}
     */
    fillDiscountFields: function (modul, invoice_elements) {
        const retInvoice_elements = [];
        if (Array.isArray(invoice_elements)) {
            // let lineNumber = 0;
            Array.prototype.forEach.call(invoice_elements, function (e, i) {
                if (e.rowtype === 0) {
                    retInvoice_elements.push(e)
                } else if (e.rowtype === 1) {
                    const el = Object.assign({}, e);
                    el.rowtype = 1;
                    el.item_countnum = 1;
                    el.item_pack = 2; // darab
                    el.item_element_name = modul.$t('invoice.textdiscount');

                    retInvoice_elements.push(el)
                }
            })
        }
        return retInvoice_elements;
    },


    convertInvoiceDatasToXmlDataObject: function (invoiceDatas, data) {


        // let xmlStr = '<?xml version="1.0" encoding="UTF-8"?>';
        // xmlStr+='<szamlak xmlns="http://schemas.nav.gov.hu/2013/szamla" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">';
        // xmlStr+='</szamlak>';
        //
        // const doc = create(xmlStr);
        //

        const arrCounters = [];
        Array.prototype.forEach.call(invoiceDatas, function (e, i) {
            arrCounters.push(Helper.Number(e.identifier_counter));
        });
        const kezdo = String(Math.min(...arrCounters));
        const zaro = String(Math.max(...arrCounters));

        const xmlObject = {};
        xmlObject.szamlak={
            '@xmlns': 'http://schemas.nav.gov.hu/2013/szamla',
            '@xmlns:xsd': 'http://www.w3.org/2001/XMLSchema',
            '@xmlns:xsi': 'http://www.w3.org/2001/XMLSchema-instance',
        };
        xmlObject.szamlak.export_datuma = moment().format('YYYY-MM-DD');
        xmlObject.szamlak.export_szla_db = invoiceDatas.length;
        xmlObject.szamlak.kezdo_ido = data.dt_from;
        xmlObject.szamlak.zaro_ido = data.dt_to;
        xmlObject.szamlak.kezdo_szla_szam = kezdo;
        xmlObject.szamlak.zaro_szla_szam = zaro;

        // szamlak.line = [];

        xmlObject.szamlak.szamla=[];
        Array.prototype.forEach.call(invoiceDatas, function (invoiceData, i) {

            console.log(invoiceData);

            // let invoiceOperation = "";
            // if (invoiceData.invoicetype === "STORNO") {
            //     invoiceOperation = "STORNO";
            // } else {
            //     invoiceOperation = "CREATE";
            // }

            const szamla = {};


            const fejlec = {};
            fejlec.szlasorszam = (invoiceData.identifier_pre_id && invoiceData.identifier_counter) ? invoiceData.identifier_pre_id + invoiceData.identifier_counter: invoiceData.identifier;

            // A számla típusa: 1-számla/2-egyszerűsített adattartalmú számla/3-módosító számla/4-érvénytelenítő számla/5-gyűjtőszámla/6-számlával egy tekintet alá eső okirat
            // clearadmin - storno számla 6-osat kap
            if (invoiceData.invoicetype === "STORNO") {
                fejlec.szlatipus = 6;
            } else {
                fejlec.szlatipus = 1;
            }

            fejlec.szladatum = invoiceData.dt_make;
            fejlec.teljdatum = invoiceData.dt_completion;
            szamla.fejlec = fejlec;


            const szamlakibocsato = {};
            szamlakibocsato.adoszam = Helper.convertAnyToString(invoiceData.from_taxnumber,8);
            if(invoiceData.from_taxnumbercountrygroup){
                szamlakibocsato.kozadoszam = Helper.convertAnyToString(invoiceData.from_taxnumbercountrygroup,8);
            }
            szamlakibocsato.nev = Helper.convertAnyToString(invoiceData.from_businesspartnername,1);
            szamlakibocsato.cim = {};
            szamlakibocsato.cim.iranyitoszam = Helper.convertAnyToString(invoiceData.from_zip,4);
            szamlakibocsato.cim.telepules = Helper.convertAnyToString(invoiceData.from_city,1);
            szamlakibocsato.cim.kozterulet_neve = Helper.convertAnyToString(invoiceData.from_public_space)+" "+Helper.convertAnyToString(invoiceData.from_nature_of_public_space)+" "+Helper.convertAnyToString(invoiceData.from_house_number)+" "+Helper.convertAnyToString(invoiceData.from_building)+" "+Helper.convertAnyToString(invoiceData.from_staircase)+" "+Helper.convertAnyToString(invoiceData.from_floor)+" "+Helper.convertAnyToString(invoiceData.from_door);
            szamla.szamlakibocsato = szamlakibocsato;

            // originalinvoicenumber
            const vevo = {};
            if(invoiceData.to_taxnumber){
                vevo.adoszam = Helper.convertAnyToString(invoiceData.to_taxnumber,8);
            }
            if(invoiceData.to_taxnumbercountrygroup){
                vevo.kozadoszam = Helper.convertAnyToString(invoiceData.to_taxnumbercountrygroup,8);
            }
            vevo.nev = Helper.convertAnyToString(invoiceData.to_businesspartnername,1);
            vevo.cim = {};
            vevo.cim.iranyitoszam = Helper.convertAnyToString(invoiceData.to_zip,4);
            vevo.cim.telepules = Helper.convertAnyToString(invoiceData.to_city,1);
            vevo.cim.kozterulet_neve = Helper.convertAnyToString(invoiceData.to_public_space)+" "+Helper.convertAnyToString(invoiceData.to_nature_of_public_space)+" "+Helper.convertAnyToString(invoiceData.to_house_number)+" "+Helper.convertAnyToString(invoiceData.to_building)+" "+Helper.convertAnyToString(invoiceData.to_staircase)+" "+Helper.convertAnyToString(invoiceData.to_floor)+" "+Helper.convertAnyToString(invoiceData.to_door);
            szamla.vevo = vevo;

            const summaryByVatRateContainer = {};

            const termek_szolgaltatas_tetelek = [];
            if(invoiceData.invoice_element){


            Array.prototype.forEach.call(invoiceData.invoice_element, function (e, i) {
                const rowTermek = {};
                rowTermek.termeknev = e.item_element_name;
                rowTermek.menny = Helper.Number(e.item_countnum,true);
                rowTermek.mertekegys = HelperNavExportXml.navGetPack(e.item_pack, data.packs);
                rowTermek.nettoar = Helper.getFormattedPrice(Helper.getRoundedNumber(Helper.Number(e.item_price_net) * Helper.Number(e.item_countnum), 2),true);
                rowTermek.nettoegysar = Helper.getFormattedPrice(Helper.getRoundedNumber(Helper.Number(e.item_price_net), 10),true);
                rowTermek.adokulcs = Helper.Number(e.item_vatpercent);
                rowTermek.adoertek = Helper.getFormattedPrice(Helper.getRoundedNumber(Helper.Number(e.item_price_vat), 2),true);
                rowTermek.bruttoar = Helper.getFormattedPrice(Helper.getRoundedNumber(Helper.Number(e.item_sumprice), 2),true);
                termek_szolgaltatas_tetelek.push(rowTermek);

                if (Number(e.rowtype) === 0) {
                    if (!summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100]) {
                        summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100] = {}
                    }
                    if (!summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateNetAmount) {
                        summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateNetAmount = 0;
                    }
                    if (!summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateNetAmount) {
                        summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateVatAmount = 0;
                    }
                    summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatPercentage = Helper.Number(e.item_vatpercent) / 100;
                    summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatPercentageNumber = Helper.Number(e.item_vatpercent);
                    summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateNetAmount = Helper.getRoundedNumber(summaryByVatRateContainer["" + (Helper.Number(e.item_vatpercent) / 100)].vatRateNetAmount + Helper.getRoundedNumber(Helper.Number(e.item_price_net) * Helper.Number(e.item_countnum), 2), 2);
                    summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateVatAmount = Helper.getRoundedNumber(summaryByVatRateContainer["" + (Helper.Number(e.item_vatpercent) / 100)].vatRateVatAmount + Helper.getRoundedNumber(Helper.Number(e.item_price_vat), 2), 2);

                } else if (Number(e.rowtype) === 1) {
                    if (!summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100]) {
                        summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100] = {}
                    }
                    if (!summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateNetAmount) {
                        summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateNetAmount = 0;
                    }
                    if (!summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateVatAmount) {
                        summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateVatAmount = 0;
                    }
                    summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatPercentage = Helper.Number(e.item_vatpercent) / 100;
                    summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatPercentageNumber = Helper.Number(e.item_vatpercent);
                    summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateNetAmount = Helper.getRoundedNumber(summaryByVatRateContainer["" + (Helper.Number(e.item_vatpercent) / 100)].vatRateNetAmount + Helper.getRoundedNumber(Helper.Number(e.item_price_net) * Helper.Number(e.item_countnum), 2), 2);
                    summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateVatAmount = Helper.getRoundedNumber(summaryByVatRateContainer["" + (Helper.Number(e.item_vatpercent) / 100)].vatRateVatAmount + Helper.getRoundedNumber(Helper.Number(e.item_price_vat), 2), 2);
                }

                });
            }
            szamla.termek_szolgaltatas_tetelek = termek_szolgaltatas_tetelek;

            if (invoiceData.originalinvoicenumber) {
                const modosito_szla = {};
                modosito_szla.eredeti_sorszam = invoiceData.originalinvoicenumber;
            }

            const nem_kotelezo = {};
            nem_kotelezo.fiz_hatarido = invoiceData.dt_paymentdeadline;
            nem_kotelezo.fiz_mod = data.payment_types['paymenttype'+invoiceData.payment_type];
            nem_kotelezo.penznem = "Ft";
            szamla.nem_kotelezo = nem_kotelezo;

            const osszesites = {};
            osszesites.afarovat = [];
            for (let i in summaryByVatRateContainer) {
                if (!summaryByVatRateContainer.hasOwnProperty(i)) {
                    continue;
                }
                let afarovat = {};
                afarovat.nettoar = Helper.getFormattedPrice(Helper.Number(summaryByVatRateContainer[i].vatRateNetAmount),true);
                afarovat.nettoar = Helper.getFormattedPrice(Helper.Number(summaryByVatRateContainer[i].vatRateNetAmount),true);
                afarovat.adokulcs = Helper.getFormattedPrice(Helper.Number(summaryByVatRateContainer[i].vatPercentageNumber),true);
                afarovat.adoertek = Helper.getFormattedPrice(Helper.Number(summaryByVatRateContainer[i].vatRateVatAmount),true);
                afarovat.bruttoar = Helper.getFormattedPrice(Helper.Number(summaryByVatRateContainer[i].vatRateNetAmount) + Helper.Number(summaryByVatRateContainer[i].vatRateVatAmount),true);
                osszesites.afarovat.push(afarovat);
            }
            osszesites.vegosszeg = {};
            osszesites.vegosszeg.nettoarossz = Helper.getFormattedSumprice(invoiceData.price_sum_net,true);
            osszesites.vegosszeg.afaertekossz = Helper.getFormattedSumprice(invoiceData.price_vat,true);
            osszesites.vegosszeg.bruttoarossz = Helper.getFormattedSumprice(invoiceData.price_sum,true);
            szamla.osszesites = osszesites;
            xmlObject.szamlak.szamla.push(szamla);
        });

        console.log(xmlObject);
        return xmlObject;
    },


    /**
     * Beleküldjük a számla adatokat
     * visszakapjuk azt a js object-et ami már struktúrában egyezik a küldendő objemtummal.
     * @param invoiceData
     * @param invoiceOperation
     * @returns {{}}
     */
    convertInvoiceDataToXmlDataObject: function (invoiceData, invoiceOperation) {

        console.log("------------invoiceData");
        console.log(JSON.stringify(invoiceData));


        let arrSupplierTaxNumber = ['', '', '']
        if (invoiceData.from_taxnumber) {
            arrSupplierTaxNumber = invoiceData.from_taxnumber.split("-");
        }
        let arrCustomerTaxNumber = ['', '', '']
        if (invoiceData.to_taxnumber) {
            arrCustomerTaxNumber = invoiceData.to_taxnumber.split("-");
        }
        const summaryByVatRate = [];
        const summaryByVatRateContainer = {};
        const line = [];

        /*
         * Az eredeti számlán szereplő tételsorok adatait tartalmazza, a mennyiségek ellentétes előjellel szerepeltetve (ebből eredően tipikusan negatív tételsor összesen adatokkal).-Az   ellentétes   előjelű   számlatételek hivatkozása (lineNumberReference)   folytatólagos sorszámot kap az eredeti számla tételeinek sorszámozását folytatva. -A  lineModificationReference/lineNumberReference vagy az  ellentételezett  tételssorszámra mutat,  a  lineOperation  értéke  „MODIFY”,  vagy  a  lineNumberReference  (a  számla  és  összes módosításai  tekintetében)  sorfolytonosan  új  tételsorszámra  mutat  és  lineOperation  értéke „CREATE”. -Az eredeti számla összegző adataiban (invoiceSummary) szereplő összegek, az eredetiszámla és  az összes  korábbi módosítás eredményeként előálló  állapothoz képest ellentétes  előjellel szerepelnek.
         * */
        if (Array.isArray(invoiceData.invoice_elements)) {
            let lineNumber = 0;
            Array.prototype.forEach.call(invoiceData.invoice_elements, function (e, i) {
                // console.log(870)
                if (Number(e.rowtype) === 0) {
                    const lineNatureIndicator = (e.rowtype === 0) ? "PRODUCT" : "OTHER"; // ha kedvezmény, akkor gondolom más -PRODUCT SERVICE OTHER
                    // let lineNumber = Number(i) + 1;
                    lineNumber++;
                    let lineNumberNewRow = lineNumber;
                    // STORNO esetén a (count) már a számla létrehozáskor negatív előjellel lesz létrehozva

                    // Ha create, akkor folytatólagos sorszámozás kell.
                    if (invoiceOperation === "STORNO") {
                        lineNumberNewRow = lineNumber + invoiceData.invoice_elements.length
                    }


                    const row = {
                        "lineNumber": lineNumber, //lineNumberNewRow,
                    };
                    // "productCodes": {
                    //     "productCode": {
                    //         "productCodeCategory": "",//"VTSZ",
                    //         "productCodeValue": "",//"16010010"
                    //     }
                    // },
                    if (invoiceOperation === "STORNO") {
                        row.lineModificationReference = {
                            lineNumberReference: lineNumber,
                            lineOperation: "MODIFY", //"CREATE", // "MODIFY" "create"
                            // vagy
                            // lineNumberReference: lineNumberNewRow,
                            // lineOperation: "CREATE", // "MODIFY" "create"

                        }
                    }

                    // const row3 = {
                    row["lineExpressionIndicator"] = "true";
                    row["lineNatureIndicator"] = lineNatureIndicator;//"PRODUCT",
                    row["lineDescription"] = "" + e.item_element_name;//"Kenőmájas",
                    row["quantity"] = "" + Helper.Number(e.item_countnum);//"40.00",
                    row["unitOfMeasure"] = HelperNavExportXml.navGetPack(e.item_pack, invoiceData.dataExtra.packs);//"KILOGRAM", getPack(packKey, invoiceData.dataExtra.packs)
                    if (row["unitOfMeasure"] === "OWN") {
                        row["unitOfMeasure"] = "PIECE";
                        // row["unitOfMeasureOwn"] = "PRICE";
                    }
                    row["unitPrice"] = "" + Helper.getRoundedNumber(Helper.Number(e.item_price_net), 10); //e.item_price;//"800.00",
                    row["lineAmountsNormal"] = {
                        "lineNetAmountData": {
                            "lineNetAmount": "" + Helper.getRoundedNumber(Helper.Number(e.item_price_net) * Helper.Number(e.item_countnum), 2),
                            "lineNetAmountHUF": "" + Helper.getRoundedNumber(Helper.Number(e.item_price_net) * Helper.Number(e.item_countnum), 2)
                        },
                        "lineVatRate": {
                            "vatPercentage": "" + (Helper.Number(e.item_vatpercent) / 100)
                        },
                        "lineVatData": {
                            "lineVatAmount": "" + Helper.getRoundedNumber(Helper.Number(e.item_price_vat), 2),
                            "lineVatAmountHUF": "" + Helper.getRoundedNumber(Helper.Number(e.item_price_vat), 2)
                        },
                        "lineGrossAmountData": {
                            "lineGrossAmountNormal": "" + Helper.getRoundedNumber(Helper.Number(e.item_sumprice), 2),
                            "lineGrossAmountNormalHUF": "" + Helper.getRoundedNumber(Helper.Number(e.item_sumprice), 2)
                        }
                    };
                    // };

                    console.log(e)
                    console.log(row)

                    line.push(row);
                    if (!summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100]) {
                        summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100] = {}
                    }
                    if (!summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateNetAmount) {
                        summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateNetAmount = 0;
                    }
                    if (!summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateNetAmount) {
                        summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateVatAmount = 0;
                    }
                    summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatPercentage = Helper.Number(e.item_vatpercent) / 100;
                    summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateNetAmount = Helper.getRoundedNumber(summaryByVatRateContainer["" + (Helper.Number(e.item_vatpercent) / 100)].vatRateNetAmount + Helper.getRoundedNumber(Helper.Number(e.item_price_net) * Helper.Number(e.item_countnum), 2), 2);
                    summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateVatAmount = Helper.getRoundedNumber(summaryByVatRateContainer["" + (Helper.Number(e.item_vatpercent) / 100)].vatRateVatAmount + Helper.getRoundedNumber(Helper.Number(e.item_price_vat), 2), 2);

                } else if (Number(e.rowtype) === 1) {
                    const lineNatureIndicator = (e.rowtype === 0) ? "PRODUCT" : "OTHER"; // ha kedvezmény, akkor gondolom más -PRODUCT SERVICE OTHER
                    // let lineNumber = Number(i) + 1;
                    lineNumber++;
                    let lineNumberNewRow = lineNumber;
                    // STORNO esetén a (count) már a számla létrehozáskor negatív előjellel lesz létrehozva

                    // Ha create, akkor folytatólagos sorszámozás kell.
                    if (invoiceOperation === "STORNO") {
                        lineNumberNewRow = lineNumber + invoiceData.invoice_elements.length
                    }


                    const row = {
                        "lineNumber": lineNumber, //lineNumberNewRow,
                    };
                    // "productCodes": {
                    //     "productCode": {
                    //         "productCodeCategory": "",//"VTSZ",
                    //         "productCodeValue": "",//"16010010"
                    //     }
                    // },
                    if (invoiceOperation === "STORNO") {
                        row.lineModificationReference = {
                            lineNumberReference: lineNumber,
                            lineOperation: "MODIFY", //"CREATE", // "MODIFY" "create"
                            // vagy
                            // lineNumberReference: lineNumberNewRow,
                            // lineOperation: "CREATE", // "MODIFY" "create"

                        }
                    }

                    // const row3 = {
                    row["lineExpressionIndicator"] = "true";
                    row["lineNatureIndicator"] = lineNatureIndicator;//"PRODUCT",
                    row["lineDescription"] = e.item_element_name;//"Kenőmájas",
                    row["quantity"] = "" + Helper.Number(e.item_countnum);//"40.00",
                    row["unitOfMeasure"] = HelperNavExportXml.navGetPack(e.item_pack, invoiceData.dataExtra.packs);//"KILOGRAM", getPack(packKey, invoiceData.dataExtra.packs)
                    row["unitPrice"] = "" + Helper.getRoundedNumber(Helper.Number(e.item_price_net), 10); //e.item_price;//"800.00",
                    row["lineAmountsNormal"] = {
                        "lineNetAmountData": {
                            "lineNetAmount": "" + Helper.getRoundedNumber(Helper.Number(e.item_price_net) * Helper.Number(e.item_countnum), 2),
                            "lineNetAmountHUF": "" + Helper.getRoundedNumber(Helper.Number(e.item_price_net) * Helper.Number(e.item_countnum), 2)
                        },
                        "lineVatRate": {
                            "vatPercentage": "" + Helper.Number(e.item_vatpercent) / 100
                        },
                        "lineVatData": {
                            "lineVatAmount": "" + Helper.getRoundedNumber(Helper.Number(e.item_price_vat), 2),
                            "lineVatAmountHUF": "" + Helper.getRoundedNumber(Helper.Number(e.item_price_vat), 2)
                        },
                        "lineGrossAmountData": {
                            "lineGrossAmountNormal": "" + Helper.getRoundedNumber(Helper.Number(e.item_sumprice), 2),
                            "lineGrossAmountNormalHUF": "" + Helper.getRoundedNumber(Helper.Number(e.item_sumprice), 2)
                        }
                    };
                    // };

                    console.log(e)
                    console.log(row)
                    line.push(row);
                    if (!summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100]) {
                        summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100] = {}
                    }
                    if (!summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateNetAmount) {
                        summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateNetAmount = 0;
                    }
                    if (!summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateVatAmount) {
                        summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateVatAmount = 0;
                    }
                    summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatPercentage = Helper.Number(e.item_vatpercent) / 100;
                    // summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateNetAmount = Helper.getRoundedNumber(summaryByVatRateContainer["" + (Helper.Number(e.item_vatpercent) / 100)].vatRateNetAmount + Helper.getFormattedPrice(Helper.Number(e.item_price_net),2),2);
                    // summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateVatAmount = Helper.getRoundedNumber(summaryByVatRateContainer["" + (Helper.Number(e.item_vatpercent) / 100)].vatRateVatAmount + Helper.getFormattedPrice(Helper.Number(e.item_price_vat),2),2);
                    summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateNetAmount = Helper.getRoundedNumber(summaryByVatRateContainer["" + (Helper.Number(e.item_vatpercent) / 100)].vatRateNetAmount + Helper.getRoundedNumber(Helper.Number(e.item_price_net) * Helper.Number(e.item_countnum), 2), 2);
                    summaryByVatRateContainer["" + Helper.Number(e.item_vatpercent) / 100].vatRateVatAmount = Helper.getRoundedNumber(summaryByVatRateContainer["" + (Helper.Number(e.item_vatpercent) / 100)].vatRateVatAmount + Helper.getRoundedNumber(Helper.Number(e.item_price_vat), 2), 2);

                }
                // else {
                // summaryByVatRate.push({
                //     "vatRate": {
                //         "vatPercentage": Helper.Number(e.item_vatpercent )/ 100
                //     },
                //     "vatRateNetData": {
                //         "vatRateNetAmount": Helper.Number(e.item_price), //"4352000.00",
                //         "vatRateNetAmountHUF": Helper.Number(e.item_price)
                //     },
                //     "vatRateVatData": {
                //         "vatRateVatAmount": Helper.Number(e.item_price_vat),
                //         "vatRateVatAmountHUF": Helper.Number(e.item_price_vat)
                //     }
                // });
                // }
            })

            for (let i in summaryByVatRateContainer) {
                if (!summaryByVatRateContainer.hasOwnProperty(i)) {
                    continue;
                }
                summaryByVatRate.push({
                    "vatRate": {
                        "vatPercentage": Helper.Number(summaryByVatRateContainer[i].vatPercentage)
                    },
                    "vatRateNetData": {
                        "vatRateNetAmount": Helper.Number(summaryByVatRateContainer[i].vatRateNetAmount), //Helper.Number(e.item_price), //"4352000.00",
                        "vatRateNetAmountHUF": Helper.Number(summaryByVatRateContainer[i].vatRateNetAmount)  //Helper.Number(e.item_price)
                    },
                    "vatRateVatData": {
                        "vatRateVatAmount": Helper.Number(summaryByVatRateContainer[i].vatRateVatAmount), //Helper.Number(e.item_price_vat),
                        "vatRateVatAmountHUF": Helper.Number(summaryByVatRateContainer[i].vatRateVatAmount)  //Helper.Number(e.item_price_vat)
                    }
                });

            }

        }


        const from_detailedAddress = {};
        // {            "countryCode": "HU",
        //     "postalCode": invoiceData.from_zip,
        //     "city": invoiceData.from_city,
        //     "streetName": invoiceData.from_public_space,
        //     "publicPlaceCategory": invoiceData.from_nature_of_public_space,
        // };
        from_detailedAddress.countryCode = "HU";
        // need codes table --> need select
        // if (invoiceData.county) {
        //     from_detailedAddress.region = invoiceData.from_county
        // }

        from_detailedAddress.postalCode = invoiceData.from_zip;
        from_detailedAddress.city = invoiceData.from_city;
        from_detailedAddress.streetName = invoiceData.from_public_space;
        from_detailedAddress.publicPlaceCategory = invoiceData.from_nature_of_public_space;

        if (invoiceData.from_house_number) {
            from_detailedAddress.number = "" + invoiceData.from_house_number
        }
        if (invoiceData.from_building) {
            from_detailedAddress.building = invoiceData.from_building
        }
        if (invoiceData.from_staircase) {
            from_detailedAddress.staircase = invoiceData.from_staircase
        }
        if (invoiceData.from_floor) {
            from_detailedAddress.floor = invoiceData.from_floor
        }
        if (invoiceData.from_door) {
            from_detailedAddress.door = invoiceData.from_door
        }
        // lotNumber  Helyrajzi szám Lot number


        const to_detailedAddress = {};
        // {
        //     "countryCode": "HU",
        //     "postalCode": invoiceData.to_zip,
        //     "city": invoiceData.to_city,
        //     "streetName": invoiceData.to_public_space,
        //     "publicPlaceCategory": invoiceData.to_nature_of_public_space,
        // };
        to_detailedAddress.countryCode = "HU";
        // need codes table --> need select
        // if (invoiceData.county) {
        //     to_detailedAddress.region = invoiceData.to_county
        // }

        to_detailedAddress.postalCode = invoiceData.to_zip;
        to_detailedAddress.city = invoiceData.to_city;
        to_detailedAddress.streetName = invoiceData.to_public_space;
        to_detailedAddress.publicPlaceCategory = invoiceData.to_nature_of_public_space;

        if (invoiceData.to_house_number) {
            to_detailedAddress.number = invoiceData.to_house_number
        }
        if (invoiceData.to_building) {
            to_detailedAddress.building = invoiceData.to_building
        }
        if (invoiceData.from_staircase) {
            to_detailedAddress.staircase = invoiceData.from_staircase
        }
        if (invoiceData.to_floor) {
            to_detailedAddress.floor = invoiceData.to_floor
        }
        if (invoiceData.to_door) {
            to_detailedAddress.door = invoiceData.to_door
        }
        // lotNumber  Helyrajzi szám Lot number

        const invoice = {};
        if (invoiceOperation === "STORNO") {
            /*
             <originalInvoiceNumber>ZZZ000001</originalInvoiceNumber>
             <modifyWithoutMaster>false</modifyWithoutMaster>
             <modificationIndex>2</modificationIndex>
             */
            invoice.invoiceReference = {
                originalInvoiceNumber: invoiceData.originalinvoicenumber, //invoiceData.identifier_pre_id + invoiceData.identifier_counter,
                modifyWithoutMaster: false,
                modificationIndex: 1
            }
        }
        invoice.invoiceHead = {
            "supplierInfo": {
                "supplierTaxNumber": {
                    "taxpayerId": arrSupplierTaxNumber[0],
                    "vatCode": arrSupplierTaxNumber[1],
                    "countyCode": arrSupplierTaxNumber[2]
                },
                "supplierName": invoiceData.from_businesspartnername,
                "supplierAddress": {
                    "detailedAddress": from_detailedAddress
                },
            },
            "customerInfo": {},
            "invoiceDetail": {
                "invoiceCategory": "NORMAL",
                "invoiceDeliveryDate": invoiceData.dt_make,
                "currencyCode": "HUF",
                "exchangeRate": "1",
                "paymentDate": invoiceData.dt_paymentdeadline,
                "invoiceAppearance": "PAPER",
                // "additionalInvoiceData": {
                //     "dataName": "X00001_MRSZ",
                //     "dataDescription": "MRSZ",
                //     "dataValue": "Megrendelés szám: 12345678/2020"
                // }
            }
        };
        if (invoiceData.from_bank_account) {
            invoice.invoiceHead.supplierInfo.supplierBankAccountNumber = invoiceData.from_bank_account;
        }
        if (arrCustomerTaxNumber[0]) {
            invoice.invoiceHead.customerInfo.customerTaxNumber = {
                "taxpayerId": arrCustomerTaxNumber[0],
                "vatCode": arrCustomerTaxNumber[1],
                "countyCode": arrCustomerTaxNumber[2]
            }
        }
        invoice.invoiceHead.customerInfo.customerName = invoiceData.to_businesspartnername;
        invoice.invoiceHead.customerInfo.customerAddress = {
            "detailedAddress": to_detailedAddress
        };
        if (invoiceData.to_bank_account) {
            invoice.invoiceHead.customerInfo.customerBankAccountNumber = invoiceData.to_bank_account;
        }
        invoice.invoiceLines = {
            "line": line


        };
        invoice.invoiceSummary = {
            "summaryNormal": {
                "summaryByVatRate": summaryByVatRate


                ,
                "invoiceNetAmount": invoiceData.price_sum_net, //"4952000.00",
                "invoiceNetAmountHUF": invoiceData.price_sum_net, //"4952000.00",
                "invoiceVatAmount": invoiceData.price_vat, //"1205040.00",
                "invoiceVatAmountHUF": invoiceData.price_vat, //"1205040.00"
            },
            "summaryGrossData": {
                "invoiceGrossAmount": invoiceData.price_sum, //"6157040.00",
                "invoiceGrossAmountHUF": invoiceData.price_sum, //"6157040.00"
            }
        }
        // };

        const obj = {
            "InvoiceData": {
                "@": {
                    "xmlns": "http://schemas.nav.gov.hu/OSA/2.0/data",
                    "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
                    "xsi:schemaLocation": "http://schemas.nav.gov.hu/OSA/2.0/data invoiceData.xsd"
                },
                "invoiceNumber": invoiceData.identifier_pre_id + invoiceData.identifier_counter,
                "invoiceIssueDate": invoiceData.dt_make,
                "invoiceMain": {
                    "invoice": invoice
                }
            }
        };


        // xmlDataObject = retInvoiceData;
        return obj;
    },


    /**
     *  ----------------------------------------------
     *  ----------------------------------------------
     *  ----------------------------------------------
     *  ----------------------------------------------
     *  ----------------------------------------------
     *  ----------------------------------------------
     * */





    /**
     * Return xsdNavExport
     */
    getXsdData: function () {
        return xsdNavExport;
    },
    /**
     * return validationErrors
     * @param xmlDataObject
     * @param xsdData
     * @returns {string|Document}
     */
    // validateXml: function (xmlDataObject, xsdData) {
    //
    //     const doc = create(xmlDataObject); //HelperNavExportXml.dataObject);
    //     const xml = doc.end({prettyPrint: true});
    //
    //     const schema = xsdData;
    //
    //     console.log(xml);
    //     console.log(schema);
    //     console.log();
    //
    //
    //     // const xmllint = require('xmllint')
    //
    //     // const schema=xsdData;
    //     // const validationErrors = xmllint.validateXML({
    //     //     xml: xml,
    //     //     schema: schema
    //     //     // xml: [xml, xml],
    //     //     // schema: [schema, schema]
    //     // });
    //
    //     console.log(validationErrors);
    //
    //     return validationErrors;
    // },

    // validateXmlBe: function (xmlDataObject, xsdData) {
    //
    //     console.log("xmlDataObject:");
    //     console.log(xmlDataObject);
    //     const doc = create(xmlDataObject); //HelperNavExportXml.dataObject);
    //     const xml = doc.end({prettyPrint: true});
    //
    //     // const schema = xsd.parse(xsdData);
    //     // const validationErrors = schema.validate(xml);
    //
    //
    //     // var fs = require('fs')
    //     //     // , xmllint = require('../xmllint.js')
    //     //     , xml = fs.readFileSync('./test/test.xml').toString()
    //     //     , schema = fs.readFileSync('./test/test.xsd').toString()
    //     // ;
    //     const schema = xsdData;
    //     console.log("xml:");
    //     console.log(xml);
    //     console.log("schema:");
    //     console.log(schema);
    //     console.log();
    //     // const xmllint = require('xmllint')
    //
    //     // const schema=xsdData;
    //     const validationErrors = {};
    //     // validationErrors = xmllint.validateXML({
    //     //     // xml: xml,
    //     //     // schema: schema
    //     //     xml: [xml, xml],
    //     //     schema: [schema, schema]
    //     // });
    //
    //     console.log("validationErrors");
    //     console.log(validationErrors);
    //
    //     return validationErrors;
    // },
    /**
     * return xml
     * @param xmlDataObject
     */
    getXml: function (xmlDataObject) {

        const doc = create(xmlDataObject);
        const xml = doc.end({prettyPrint: false,allowEmpty: true });
        console.log(doc.end({prettyPrint: true,allowEmpty: true }))
        // HelperNavExportXml.xml=xml;
        return xml;
    },


};

export default HelperNavExportXml
